import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import lt from 'translations/lt.json';
import en from 'translations/en.json';
import ro from 'translations/ro.json';
import pt from 'translations/pt.json';

import { SUPPORTED_LANGUAGES } from './constants';
import { LanguageValues } from '../models';

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			lt,
			en,
			ro,
			pt
		},
		supportedLngs: SUPPORTED_LANGUAGES,
		fallbackLng: 'en',
		keySeparator: false,
		interpolation: {
			escapeValue: false,
		},
		detection: {
			order: ['path'],
			lookupFromPathIndex: 0,
		},
	});

export const setCurrentLanguage = (language: string) => i18n.changeLanguage(language).then();

export const getLanguage = () => i18n.language;

export const language = getLanguage() as LanguageValues;

export const isLT = language === 'lt';

export default i18n;
